import { isNonEmptyString } from "./Core";
import { SwgyHeaderKeysList } from "@swiggy-private/core-types";
import { GlobalHeaderState } from "./Headers";
import { isAndroidPlatform } from "@checkout-core/helpers/getSwiggyHeaders";

export const isInsetValueValid = (statusBarHeight = "", bottomOffset = ""): boolean => {
    // check if both statusBarHeight and bottomOffset empty do early return false
    if (!isNonEmptyString(statusBarHeight) || !isNonEmptyString(bottomOffset)) {
        return false;
    }
    return !isNaN(Number(statusBarHeight)) && !isNaN(Number(bottomOffset));
};

export const allowInsetsForAndroid = (): boolean => {
    const platform = GlobalHeaderState.getHeader(SwgyHeaderKeysList.platform) || "";
    const fullScreenStatusBarHeight = String(
        GlobalHeaderState.getHeader(SwgyHeaderKeysList.fullScreenStatusBarHeight) || "",
    );
    const fullScreenBottomOffset = String(GlobalHeaderState.getHeader(SwgyHeaderKeysList.fullScreenBottomOffset) || "");
    return isAndroidPlatform(platform) && isInsetValueValid(fullScreenStatusBarHeight, fullScreenBottomOffset);
};
